export const GET_USER_LIST_BEGIN = "GET_USER_LIST_BEGIN";
export const GET_USER_LIST_SUCCESS = "GET_USER_LIST_SUCCESS";
export const GET_USER_LIST_FAILURE = "GET_USER_LIST_FAILURE";

export const USER_ACTION_BEGIN = "USER_ACTION_BEGIN";
export const USER_ACTION_SUCCESS = "USER_ACTION_SUCCESS";
export const USER_ACTION_FAILURE = "USER_ACTION_FAILURE";
